import { useTheme } from '@mui/material/styles';
export const useStyles = () => {
    const theme = useTheme();
    return {
        root: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            marginTop: theme.spacing(3),
            width: '100%',
            flexGrow: 1,
        },
        title: {
            [theme.breakpoints.up('sm')]: {
                fontSize: '3rem',
                marginBottom: theme.spacing(2),
            },
            fontSize: '2rem',
            marginTop: theme.spacing(4),
            marginBottom: theme.spacing(1.5),
        },
        description: {
            marginBottom: theme.spacing(4),
        },
    };
};
